module.exports = __webpack_public_path__ + "img/jovenes-comprimido-03.5c0603cc.png";